
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.2 17.8857V9.00178C4.2 8.38934 3.73078 7.89128 3.15 7.89128H0V18.9999H3.15C3.73078 18.9999 4.2 18.5018 4.2 17.8857Z"}}),_c('path',{attrs:{"d":"M18.7751 8.34725H15.1567C14.8389 8.34725 14.6819 8.14381 14.6283 8.05504C14.5747 7.96626 14.4675 7.73323 14.6206 7.46691C15.3788 6.14272 16.5623 4.23923 15.54 2.73379C14.4374 1.54966 12.5863 1.88458 12.18 3.12434C11.5348 5.09332 9.74235 6.36267 8.34494 7.87009C7.83951 8.41383 7.56 9.11661 7.56 9.84899V16.0409C7.56 17.6721 8.9346 19 10.6232 19H16.7189C18.0935 19 19.3111 18.1049 19.6749 16.8251C20.1037 14.9201 20.6053 13.0263 20.9576 11.1029C21.2065 9.73063 20.3449 8.34725 18.7751 8.34725Z"}})])
          )
        }
      }
    